const RESOURCE_ORDER = ['stelline', 'learned_terms', 'gettoncini'];

export const summarizeGuestRewards = (claims = [], signupAmount = 0) => {
  const groups = new Map();
  claims.forEach((claim) => {
    if (!RESOURCE_ORDER.includes(claim.resource)) return;
    const expiresAt = Date.parse(claim.expires_at);
    const amount = Number(claim.amount);
    if (!Number.isFinite(amount) || amount <= 0 || !Number.isFinite(expiresAt) || expiresAt <= Date.now()) return;
    const group = groups.get(claim.resource) || { key: claim.resource, resource: claim.resource, amount: 0 };
    group.amount += amount;
    groups.set(claim.resource, group);
  });
  const welcomeBonus = Number(signupAmount);
  if (Number.isFinite(welcomeBonus) && welcomeBonus > 0) {
    const coins = groups.get('gettoncini') || { key: 'gettoncini', resource: 'gettoncini', amount: 0 };
    coins.amount += welcomeBonus;
    groups.set('gettoncini', coins);
  }
  return RESOURCE_ORDER.map((resource) => groups.get(resource)).filter(Boolean);
};

export const guestRewardLabel = (reward) => ({
  stelline: 'stelline',
  learned_terms: 'parole nella tua lista personale',
  gettoncini: 'gettoncini · da usare per sbloccare gli hint di gioco',
})[reward.resource];

export const guestRewardAuthMessage = (claims) => {
  const rewards = summarizeGuestRewards(claims);
  return rewards.length
    ? 'Dopo l’accesso riceverai i tuoi premi.'
    : null;
};
